const section = (key, type, enabled = true, settings = {}, blocks = []) => ({
  key,
  type,
  enabled,
  settings,
  layout: {},
  blocks,
});

const blocksFromItems = (type, items) => (Array.isArray(items) ? items : []).map((item, index) => ({
  key: `${type.replaceAll('_', '-')}-${index + 1}`,
  type,
  enabled: true,
  settings: item,
}));

export const buildLegacyHomeLayout = (settings = {}) => ({
  schemaVersion: 1,
  compatibilityMode: true,
  template: {
    key: 'home',
    resourceType: 'home',
    sections: [
      section('hero', 'hero', settings.themeShowHero !== false, {
        title: settings.themeHeroTitle || '',
        subtitle: settings.themeHeroSubtitle || '',
        image: settings.themeHeroImage || '',
        ctaLabel: '',
        ctaUrl: '/products',
      }),
      section('trust-strip', 'trust_strip'),
      section('reviews', 'reviews', settings.themeShowReviews !== false),
      section('testimonials', 'testimonials', !!settings.themeShowTestimonials, { heading: '' }, blocksFromItems('testimonial', settings.themeTestimonials)),
      section('featured-products', 'featured_products', settings.themeShowBestsellers !== false, { heading: '', subtitle: '', limit: 6 }),
      section('collections', 'collections', settings.themeShowCollections !== false, { heading: '', subtitle: '', limit: 3 }),
      section('image-with-text', 'image_with_text', !!settings.themeShowSplit, {
        heading: settings.themeSplitHeading || '',
        body: settings.themeSplitBody || '',
        image: settings.themeSplitImage || '',
        ctaLabel: settings.themeSplitCtaLabel || '',
        ctaUrl: settings.themeSplitCtaUrl || '',
      }),
      section('feature-columns', 'feature_columns', !!settings.themeShowFeatureColumns, { heading: '' }, blocksFromItems('feature', settings.themeFeatureColumns)),
      section('static-features', 'static_features'),
      section('bundles', 'bundles', true, { limit: 3 }),
      section('recently-viewed', 'recently_viewed', true, { minimumItems: 3, limit: 6 }),
      section('faq', 'faq', !!settings.themeShowFaq, { heading: '' }, blocksFromItems('faq_item', settings.themeFaqItems)),
      section('newsletter', 'newsletter'),
    ],
  },
});

export const isHomeLayout = (layout) => (
  layout?.template?.key === 'home' && Array.isArray(layout?.template?.sections)
);

export const applyLegacyThemeSettings = (layout, settings = {}) => {
  const source = isHomeLayout(layout) ? layout : buildLegacyHomeLayout(settings);
  if (source.compatibilityMode === false) return source;

  const current = buildLegacyHomeLayout(settings);
  const compatibilitySections = new Map(current.template.sections.map((item) => [item.key, item]));
  return {
    ...source,
    template: {
      ...source.template,
      sections: source.template.sections.map((item) => {
        const compatibility = compatibilitySections.get(item.key);
        if (!compatibility) return item;
        return {
          ...item,
          enabled: compatibility.enabled,
          settings: { ...item.settings, ...compatibility.settings },
          blocks: compatibility.blocks.length > 0 || ['testimonials', 'feature-columns', 'faq'].includes(item.key)
            ? compatibility.blocks
            : (item.blocks || []),
        };
      }),
    },
  };
};
